import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=163e119b&"
import script from "./Header.js?vue&type=script&lang=js&"
export * from "./Header.js?vue&type=script&lang=js&"
import style0 from "./Header.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports